import "./Styles/CommercialOfferWithSampleIndexesStyles.css";

import { useEffect, useRef, useState } from "react";
import ErrorBoundary from "../../Components/ErrorBoundary/ErrorBoundary";
import MobileAccountNavBar from "../../Components/MobileComponents/NavBarMobile.jsx/MobileAccountNavBar";
import { AccountCurrentView } from "../../Data/PageModeEnums.ts";
import { useParams } from "../../Providers/ParamsProvider";
import { useNavigate } from "react-router-dom";
import {
  TreeList,
  Column,
  Editing,
  HeaderFilter,
  Scrolling,
  ColumnChooser,
  RangeRule,
  CustomRule,
  LoadPanel,
} from "devextreme-react/tree-list";
import NoAccess from "../../Components/NoAccess";
import { useAuth } from "../../Providers/AuthProvider";
import { toast } from "react-toastify";
import SaveCommercialOfferWithSampleIndexesDataModal from "./Components/SaveCommercialOfferWithSampleIndexesDataModal.jsx";
import { FaSquare } from "react-icons/fa";
import useCommercialOfferWithSample from "../../Hooks/useCommercialOfferWithSample.jsx";
import TableLoadingSpinner from "../../Components/Components/TableLoadingSpinner.jsx";
import ScrollUpArrow from "../../Components/Components/ScrollUpArrow.jsx";
import LoadingModal from "../../Components/Components/Modals/LoadingModal.jsx";
import useGetProductIndexWithMask from "../../Components/BasketPage/Hooks/useGetProductIndexWithMask.jsx";
import useCheckLicense from "../../Hooks/useCheckLicense.ts";
import { Licenses } from "../../Data/Licenses.ts";

const CommercialOfferWithSampleIndexesPageIndex = () => {
  const navigate = useNavigate();
  const { checkLicense } = useCheckLicense();
  const { authState } = useAuth();
  const { isMobile } = useParams();
  const { getProductIndexWithMask } = useGetProductIndexWithMask();
  const {
    handleGetCommercialOfferStarterData,
    hendleGetCommercialOfferAssortsForDiscountGroup,
    handleRecalculateCustomerDiscount,
    handleRecalculateCustomerDiscountForArtNo,
    handleSaveCustomerHanDiscounts,
    handleCheckUnfinishedTaskForSendPriceList,
  } = useCommercialOfferWithSample();
  const [showZapasMaks, setShowZapasMaks] = useState(
    checkLicense(Licenses.TgInstalacje),
  );

  // Sprawdzanie procesu w tle (generowanie cennika) przed załadowaniem pozycji
  const [isCheckingTask, setIsCheckingTask] = useState(true);
  const [hasUnfinishedTask, setHasUnfinishedTask] = useState(false);

  const [updatedDiscounts, setUpdatedDiscounts] = useState(null);
  const [updatedInvestmentDiscounts, setUpdatedInvestmentDiscounts] =
    useState(null);
  const [showSaveModal, setShowSaveModal] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [isExpandingAll, setIsExpandingAll] = useState(false);
  // Spinner przy pobieraniu / przeliczaniu danych
  const [isLoading, setIsLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState(
    "Trwa ładowanie danych...",
  );
  const fetchedGroupsRef = useRef(new Set());
  const treeListRef = useRef(null);
  // Czy ostatnia edycja dotyczyła rabatu klienta (wtedy przeliczamy przez API)
  const customerDiscountEditedRef = useRef(false);

  // TODO
  // Dla updatedDiscounts oraz updatedInvestmentDiscounts mamy za malo danych sama nazwa nie wystarczy bo nie wiemy z czego dokładnie -
  // z której podgrupy został edytowany trzeba im jakies identyfikatory wymyślić

  useEffect(() => {
    initData();
  }, []);

  // Wejście do okna: najpierw sprawdzamy czy nie trwa generowanie cennika w tle.
  // Pozycje ładujemy dopiero gdy endpoint zwróci false (brak działającego procesu).
  const initData = async () => {
    setIsCheckingTask(true);
    const hasTask = await handleCheckUnfinishedTaskForSendPriceList(
      authState.selectedCustomerData.custId,
    );
    setIsCheckingTask(false);

    if (hasTask === false) {
      setHasUnfinishedTask(false);
      fetchData();
    } else {
      setHasUnfinishedTask(true);
    }
  };

  const transformApiData = (apiData) => {
    const flatData = [];

    apiData.forEach((group) => {
      flatData.push({
        id: group.discountGroupSymbol,
        parentId: 0,
        nazwa: group.discountGroupName,
        zapas0101: group.maxStock1,
        zapas0201: group.maxStock2,
      });

      group.items?.forEach((item) => {
        flatData.push({
          id: item.discountGroupItemSymbol,
          parentId: group.discountGroupSymbol,
          id_gr: item.discountGroupItemSymbol,
          t: item.t,
          nazwa: item.discountGroupItemName,
          dostawca: item.supplierName,
          rabatKlienta: item.customerDiscount,
          cenaKlienta: item.customerPrice,
          waluta: item.currency,
          rabatOdCenDost: item.supplierDiscountPrice,
          rabatDost: item.supplierDiscount,
          rabatInwe: item.discountInw,
          grd: item.grd,
          marzaMin: item.minimalMargin,
          marza: item.margin,
          marzaKlienta: item.customerMargin,
          marzaBonus: item.marginTotal,
          max: item.marginMax,
          max3: item.marginMax3,
          zapas0101: item.maxStock1,
          zapas0201: item.maxStock2,
          // Flagi do kolorowania komórek na czerwono
          customerMarginBelowMin: item.customerMarginBelowMin,
          marginTotalBelowMin: item.marginTotalBelowMin,
          // Pola potrzebne do przeliczenia rabatu (nie wyświetlane)
          baseCustomerDiscount: item.baseCustomerDiscount,
          costRatio: item.costRatio,
        });

        item.assorts?.forEach((assort) => {
          flatData.push({
            id: assort.artNo,
            idWithMask: getProductIndexWithMask(assort.artNo),
            parentId: item.discountGroupItemSymbol,
            r: assort.rotation,
            t: assort.t,
            nazwa: assort.artName,
            dostawca: assort.supplierName,
            supplierId: assort.supplierId,
            rabatKlienta: assort.discount,
            cenaKlienta: assort.salePriceNet,
            waluta: assort.currency,
            rabatOdCenDost: assort.supplierDiscountPrice,
            rabatDost: assort.supplierDiscount,
            rabatInwe: assort.discountInw,
            grd: assort.grd,
            marzaMin: assort.minimalMargin,
            marza: assort.margin,
            marzaKlienta: assort.customerMargin,
            marzaBonus: assort.marginTotal,
            max: assort.marginMax,
            max3: assort.marginMax3,
            zapas0101: assort.maxStock1,
            zapas0201: assort.maxStock2,
            // Flagi do kolorowania komórek na czerwono
            customerMarginBelowMin: assort.customerMarginBelowMin,
            marginTotalBelowMin: assort.marginTotalBelowMin,
            // Pola potrzebne do przeliczenia rabatu (nie wyświetlane)
            assortPriceNet: assort.assortPriceNet,
            baseDiscount: assort.baseDiscount,
            costRatio: assort.costRatio,
          });
        });
      });
    });

    return flatData;
  };

  const fetchData = async () => {
    setLoadingMessage("Trwa ładowanie danych...");
    setIsLoading(true);
    try {
      const data = await handleGetCommercialOfferStarterData(
        authState.selectedCustomerData.siteId,
        authState.selectedCustomerData.whId,
        authState.selectedCustomerData.custId,
      );
      if (data) {
        setDataSource(transformApiData(data));
      }
    } catch (error) {
      console.error("Error fetching commercial offer data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const transformAssortData = (assorts) => {
    return assorts.map((assort) => ({
      id: assort.artNo,
      idWithMask: getProductIndexWithMask(assort.artNo),
      parentId: assort.discountGroupItemSymbol,
      r: assort.rotation,
      t: assort.t,
      nazwa: assort.artName,
      dostawca: assort.supplierName,
      supplierId: assort.supplierId,
      rabatKlienta: assort.discount,
      cenaKlienta: assort.salePriceNet,
      waluta: assort.currency,
      rabatOdCenDost: assort.supplierDiscountPrice,
      rabatDost: assort.supplierDiscount,
      rabatInwe: assort.discountInw,
      grd: assort.grd,
      marzaMin: assort.minimalMargin,
      marza: assort.margin,
      marzaKlienta: assort.customerMargin,
      marzaBonus: assort.marginTotal,
      max: assort.marginMax,
      max3: assort.marginMax3,
      zapas0101: assort.maxStock1,
      zapas0201: assort.maxStock2,
      // Flagi do kolorowania komórek na czerwono
      customerMarginBelowMin: assort.customerMarginBelowMin,
      marginTotalBelowMin: assort.marginTotalBelowMin,
      // Pola potrzebne do przeliczenia rabatu (nie wyświetlane)
      assortPriceNet: assort.assortPriceNet,
      baseDiscount: assort.baseDiscount,
      costRatio: assort.costRatio,
    }));
  };

  const handleExpandAll = async () => {
    const instance = treeListRef.current?.instance;
    if (!instance) {
      return;
    }

    setLoadingMessage("Trwa ładowanie danych...");
    setIsExpandingAll(true);
    try {
      const groups = dataSource.filter((r) => r.parentId === 0);
      const unfetchedGroups = groups.filter(
        (g) => !fetchedGroupsRef.current.has(g.id),
      );

      if (unfetchedGroups.length > 0) {
        unfetchedGroups.forEach((g) => fetchedGroupsRef.current.add(g.id));

        const allItemIds = unfetchedGroups.flatMap((group) =>
          dataSource
            .filter((r) => r.parentId === group.id)
            .map((item) => item.id),
        );

        if (allItemIds.length > 0) {
          const data = await hendleGetCommercialOfferAssortsForDiscountGroup(
            authState.selectedCustomerData.siteId,
            authState.selectedCustomerData.whId,
            authState.selectedCustomerData.custId,
            allItemIds,
          );
          if (data?.length > 0) {
            setDataSource((prev) => [...prev, ...transformAssortData(data)]);
          }
        }
      }

      // Poziom 0 i 1 istnieje już w dataSource przed fetchem — rozwijamy je po re-renderze
      const toExpand = dataSource.filter((r) => r.parentId === 0 || r.id_gr);
      setTimeout(() => {
        toExpand.forEach((r) => instance.expandRow(r.id));
        setIsExpandingAll(false);
      }, 50);
    } catch (error) {
      setIsExpandingAll(false);
    }
  };

  const handleCollapseAll = () => {
    const instance = treeListRef.current?.instance;
    if (!instance) {
      return;
    }
    setIsExpandingAll(true);
    setTimeout(() => {
      dataSource
        .filter((r) => r.parentId === 0)
        .forEach((r) => instance.collapseRow(r.id));
      setIsExpandingAll(false);
    }, 50);
  };

  const onRowExpanded = async (e) => {
    const groupId = e.key;
    const node = e.component.getNodeByKey(groupId);

    if (node?.level !== 0) {
      return;
    }
    if (fetchedGroupsRef.current.has(groupId)) {
      return;
    }

    fetchedGroupsRef.current.add(groupId);

    const childItems = node?.children ?? [];

    const loadingPlaceholders = childItems.map((childNode) => ({
      id: `__loading__${childNode.key}`,
      parentId: childNode.key,
      _isLoading: true,
    }));
    setDataSource((prev) => [...prev, ...loadingPlaceholders]);

    const discountGroupIds = childItems.map((c) => c.key);
    const data = await hendleGetCommercialOfferAssortsForDiscountGroup(
      authState.selectedCustomerData.siteId,
      authState.selectedCustomerData.whId,
      authState.selectedCustomerData.custId,
      discountGroupIds,
    );

    const newAssorts = data?.length ? transformAssortData(data) : [];
    const placeholderIds = new Set(loadingPlaceholders.map((p) => p.id));
    setDataSource((prev) => [
      ...prev.filter((row) => !placeholderIds.has(row.id)),
      ...newAssorts,
    ]);
  };

  // Formatowanie wizualne wierszy (nagłówki grup)
  const onRowPrepared = (e) => {
    if (e.rowType === "data") {
      if (e.node?.level === 0) {
        e.rowElement.style.backgroundColor =
          "var(--commercialOfferWithSampleIndexesHeaderColor)";
        e.rowElement.style.color = "#FFFFFF";
      }
    }
  };

  // Kolorowanie edytowanych komórek
  const onCellPrepared = (e) => {
    if (e.rowType === "data") {
      if (e.data?._isLoading) {
        e.cellElement.innerHTML = "";
        return;
      }
      if (e.column.dataField === "rabatKlienta") {
        if (updatedDiscounts && updatedDiscounts[e.key] !== undefined) {
          e.cellElement.style.backgroundColor = "var(--secondary)";
          e.cellElement.style.fontWeight = "bold";
        }
      }
      if (e.column.dataField === "rabatInwe") {
        if (
          updatedInvestmentDiscounts &&
          updatedInvestmentDiscounts[e.key] !== undefined
        ) {
          e.cellElement.style.backgroundColor = "var(--secondary)";
          e.cellElement.style.fontWeight = "bold";
        }
      }
      // Czerwone tło gdy marża poniżej minimalnej (ustawiamy/czyścimy, bo DevExtreme
      // reużywa komórki — flaga może się zmienić po przeliczeniu rabatu)
      if (e.column.dataField === "marzaKlienta") {
        const below = e.data?.customerMarginBelowMin;
        e.cellElement.style.backgroundColor = below ? "var(--bs-danger, red)" : "";
        e.cellElement.style.color = below ? "#FFFFFF" : "";
      }
      if (e.column.dataField === "marzaBonus") {
        const below = e.data?.marginTotalBelowMin;
        e.cellElement.style.backgroundColor = below ? "var(--bs-danger, red)" : "";
        e.cellElement.style.color = below ? "#FFFFFF" : "";
      }
    }
  };

  // Rozwijanie/zwijanie grupy także po kliknięciu w wiersz (nie tylko w trójkącik)
  const onCellClick = (e) => {
    if (e.rowType !== "data") {
      return;
    }
    // Komórki edytowalne (rabaty) zostawiamy do edycji
    if (
      e.column?.dataField === "rabatKlienta" ||
      e.column?.dataField === "rabatInwe"
    ) {
      return;
    }
    // Klik w samą ikonę rozwijania obsługuje już grid — nie dublujemy
    if (e.event?.target?.closest(".dx-treelist-icon-container")) {
      return;
    }
    const node = e.component.getNodeByKey(e.key);
    if (!node?.hasChildren) {
      return;
    }
    if (e.component.isRowExpanded(e.key)) {
      e.component.collapseRow(e.key);
    } else {
      e.component.expandRow(e.key);
    }
  };

  const onEditorPreparing = (e) => {
    if (e.row?.data?._isLoading) {
      e.editorOptions.disabled = true;
      return;
    }
    if (e.dataField === "rabatKlienta" || e.dataField === "rabatInwe") {
      //Blokujemy edycję rabatu dla najwyższego poziomu
      if (e.row?.node?.level === 0) {
        e.editorOptions.disabled = true;
      } else {
        //Blokujemy wpisywanie z klawiatury specyficznych znaków
        e.editorOptions.onKeyDown = (args) => {
          const invalidKeys = ["e", "E", "-", "+"];
          if (invalidKeys.includes(args.event.key)) {
            args.event.preventDefault();
          }
        };
        //Po wejściu w edycję zaznaczamy bieżącą wartość komórki
        e.editorOptions.onFocusIn = (args) => {
          const input = args.element.querySelector("input.dx-texteditor-input");
          if (input) {
            input.select();
          }
        };
      }
    }
  };

  const onRowUpdating = (e) => {
    customerDiscountEditedRef.current = e.newData.rabatKlienta !== undefined;
    if (!authState.user?.upR_SYS_EDYCJA_RABATU_KONTRAHENTA) {
      e.cancel = true;
      e.component.cancelEditData();
      toast.warning("Brak uprawnień");
      return;
    }
    if (e.newData.rabatKlienta !== undefined) {
      if (!checkDiscountPerrmision(e.newData.rabatKlienta, e.oldData?.max)) {
        e.cancel = true;
        e.component.cancelEditData();
        toast.warning(`Rabat przekracza dozwoloną wartość maksymalną!`);
        return;
      }
      setUpdatedDiscounts((prev) => ({
        ...prev,
        [e.key]: e.newData.rabatKlienta,
      }));
    }
    if (e.newData.rabatInwe !== undefined) {
      setUpdatedInvestmentDiscounts((prev) => ({
        ...prev,
        [e.key]: e.newData.rabatInwe,
      }));
    }
  };

  // Budowa obiektu DiscountGroupItem na podstawie wiersza grupy (poziom 1)
  const buildItemPayload = (row) => ({
    discountGroupItemSymbol: row.id_gr ?? row.id,
    discountGroupItemName: row.nazwa,
    t: row.t,
    supplierName: row.dostawca,
    baseCustomerDiscount: row.baseCustomerDiscount,
    customerDiscount: row.rabatKlienta,
    customerPrice: row.cenaKlienta,
    currency: row.waluta,
    supplierDiscountPrice: row.rabatOdCenDost,
    supplierDiscount: row.rabatDost,
    discountInw: row.rabatInwe,
    grd: row.grd,
    minimalMargin: row.marzaMin,
    margin: row.marza,
    customerMargin: row.marzaKlienta,
    marginTotal: row.marzaBonus,
    marginMax: row.max,
    marginMax3: row.max3,
    maxStock1: row.zapas0101,
    maxStock2: row.zapas0201,
    costRatio: row.costRatio,
    assorts: [],
  });

  // Budowa obiektu DiscountGroupAssort na podstawie wiersza indeksu (poziom 2)
  const buildAssortPayload = (row) => ({
    discountGroupItemSymbol: row.parentId,
    artNo: row.id,
    artName: row.nazwa,
    rotation: row.r,
    t: row.t,
    supplierId: row.supplierId,
    supplierName: row.dostawca,
    currency: row.waluta,
    assortPriceNet: row.assortPriceNet,
    salePriceNet: row.cenaKlienta,
    baseDiscount: row.baseDiscount,
    discount: row.rabatKlienta,
    // true tylko gdy rabat klienta został ręcznie zmieniony na tym indeksie
    discountChanged: row.discountChanged ?? false,
    supplierDiscountPrice: row.rabatOdCenDost,
    supplierDiscount: row.rabatDost,
    discountInw: row.rabatInwe,
    grd: row.grd,
    minimalMargin: row.marzaMin,
    margin: row.marza,
    customerMargin: row.marzaKlienta,
    marginTotal: row.marzaBonus,
    marginMax: row.max,
    marginMax3: row.max3,
    maxStock1: row.zapas0101,
    maxStock2: row.zapas0201,
    costRatio: row.costRatio,
  });

  // Podmiana w wierszu indeksu wartości przeliczonych przez API
  const applyAssortResult = (row, assort) => ({
    ...row,
    t: assort.t,
    rabatKlienta: assort.discount,
    cenaKlienta: assort.salePriceNet,
    marzaKlienta: assort.customerMargin,
    marzaBonus: assort.marginTotal,
    rabatOdCenDost: assort.supplierDiscountPrice,
    customerMarginBelowMin: assort.customerMarginBelowMin,
    marginTotalBelowMin: assort.marginTotalBelowMin,
  });

  // Po edycji rabatu klienta przeliczamy dane przez API i podmieniamy w widoku
  const onRowUpdated = async (e) => {
    // Przeliczamy tylko gdy zmieniono rabat klienta (rabat inwe. nie wymaga przeliczenia)
    if (!customerDiscountEditedRef.current) {
      return;
    }
    const row = e.data;
    if (!row || row.parentId === 0) {
      return;
    }

    const isItem = !!row.id_gr;
    setLoadingMessage("Trwa przeliczanie danych...");
    setIsLoading(true);
    try {
      // ── Poziom indeksu (pojedyncza pozycja) ──
      if (!isItem) {
        // Ręczna edycja rabatu na pojedynczym indeksie -> flaga DiscountChanged = true
        const result = await handleRecalculateCustomerDiscountForArtNo({
          ...buildAssortPayload(row),
          discountChanged: true,
        });
        if (!result) {
          toast.error("Błąd podczas przeliczania rabatu");
          return;
        }
        setDataSource((prev) =>
          prev.map((r) =>
            r.id === e.key
              ? { ...applyAssortResult(r, result), discountChanged: true }
              : r,
          ),
        );
        return;
      }

      // ── Poziom grupy 3-zn ──
      // Wysyłamy indeksy w stanie bieżącym (Discount + T). To API decyduje, które
      // dziedziczą rabat grupy (T='%'), a które z własnym rabatem (T='R') zostają.
      const childAssorts = dataSource.filter(
        (r) => r.parentId === row.id && !r.id_gr && !r._isLoading,
      );

      const payload = buildItemPayload(row);
      payload.assorts = childAssorts.map((c) => buildAssortPayload(c));

      const result = await handleRecalculateCustomerDiscount(payload);
      if (!result) {
        toast.error("Błąd podczas przeliczania rabatu");
        return;
      }

      const recalculatedAssorts = new Map(
        (result.assorts ?? []).map((a) => [a.artNo, a]),
      );

      setDataSource((prev) =>
        prev.map((r) => {
          if (r.id === e.key) {
            return {
              ...r,
              t: result.t,
              rabatKlienta: result.customerDiscount,
              marzaKlienta: result.customerMargin,
              marzaBonus: result.marginTotal,
              rabatOdCenDost: result.supplierDiscountPrice,
              customerMarginBelowMin: result.customerMarginBelowMin,
              marginTotalBelowMin: result.marginTotalBelowMin,
            };
          }
          const assort =
            r.parentId === row.id ? recalculatedAssorts.get(r.id) : null;
          return assort ? applyAssortResult(r, assort) : r;
        }),
      );

      // Tylko indeksy dziedziczące (T != 'R') przejęły rabat grupy — je oznaczamy
      const inheritedAssorts = (result.assorts ?? []).filter(
        (a) => a.t !== "R",
      );
      if (inheritedAssorts.length > 0) {
        setUpdatedDiscounts((prev) => {
          const next = { ...prev };
          inheritedAssorts.forEach((a) => {
            next[a.artNo] = a.discount;
          });
          return next;
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  const checkDiscountPerrmision = (discount, marginMax) => {
    if (
      discount === undefined ||
      discount === null ||
      marginMax == undefined ||
      marginMax == null
    ) {
      return true;
    }
    if (discount > marginMax) {
      return false;
    }
    return true;
  };

  const validateDecimalPlaces = (e) => {
    if (e.value === undefined || e.value === null) {
      return true;
    }
    const strVal = e.value.toString();
    if (strVal.includes(".")) {
      return strVal.split(".")[1].length <= 2;
    }
    return true;
  };

  const handleSaveChangesButtonClick = () => {
    if (!updatedDiscounts && !updatedInvestmentDiscounts) {
      toast.info("Brak zmian do zapisania");
      return;
    }
    setShowSaveModal(true);
  };

  // Składamy listę grup 3-zn do zapisu: tylko te, w których zmieniono rabat
  // na samej grupie lub na którejś z jej pozycji (wraz ze zmienionymi pozycjami)
  const buildDiscountsToSave = () => {
    const changedIds = new Set([
      ...Object.keys(updatedDiscounts ?? {}),
      ...Object.keys(updatedInvestmentDiscounts ?? {}),
    ]);

    return dataSource
      .filter((r) => r.id_gr)
      .map((group) => {
        const changedPositions = dataSource.filter(
          (r) =>
            r.parentId === group.id &&
            !r.id_gr &&
            !r._isLoading &&
            changedIds.has(r.id),
        );
        const groupChanged = changedIds.has(group.id);
        if (!groupChanged && changedPositions.length === 0) {
          return null;
        }
        return {
          ...buildItemPayload(group),
          assorts: changedPositions.map(buildAssortPayload),
        };
      })
      .filter(Boolean);
  };

  const handleSaveModalOnHide = async (answer) => {
    if (!answer) {
      setShowSaveModal(false);
      return;
    }

    const discountsToSave = buildDiscountsToSave();
    if (discountsToSave.length === 0) {
      toast.info("Brak zmian do zapisania");
      setShowSaveModal(false);
      return;
    }

    const result = await handleSaveCustomerHanDiscounts(
      authState.selectedCustomerData.custId,
      answer.expiredDate ?? null,
      discountsToSave,
    );

    if (result) {
      toast.success("Zmiany zostały zapisane");
      setUpdatedDiscounts(null);
      setUpdatedInvestmentDiscounts(null);
      setShowSaveModal(false);
      navigate("/Shop");
      return;
    }

    toast.error("Błąd podczas zapisywania zmian");
    setShowSaveModal(false);
  };

  let warningTextVisibility =
    updatedDiscounts || updatedInvestmentDiscounts ? "visible" : "hidden";

  if (!authState.user?.isOperator) {
    return <NoAccess />;
  }
  if (!authState.custId) {
    return <NoAccess customErrorText="Brak wybranego kontrahenta!" />;
  }
  if (isCheckingTask) {
    return (
      <div className="container main-container-holder">
        <div className="d-flex flex-column align-items-center justify-content-center mt-5">
          <TableLoadingSpinner />
        </div>
      </div>
    );
  }
  if (hasUnfinishedTask) {
    return (
      <div className="container main-container-holder">
        <div
          className="d-flex flex-column align-items-center justify-content-center text-center mt-5"
          style={{ fontSize: "25px" }}
        >
          <span className="mt-5">
            Oczekiwanie na wygenerowanie nowego cennika, spróbuj ponownie za
            chwilę
          </span>
          <button className="btn-app-primary mt-4" onClick={initData}>
            Sprawdź ponownie
          </button>
        </div>
      </div>
    );
  }
  return (
    <>
      <LoadingModal
        show={isExpandingAll || isLoading}
        title="Proszę czekać"
        message={loadingMessage}
      />
      <ErrorBoundary>
        <ScrollUpArrow
        //color='black'
        />
        <SaveCommercialOfferWithSampleIndexesDataModal
          show={showSaveModal}
          onHide={handleSaveModalOnHide}
        />
        <div
          className="container-fluid mt-4 mb-4"
          style={{ marginBottom: isMobile ? "80px" : "0px" }}
        >
          {isMobile && (
            <div className="mb-2">
              <MobileAccountNavBar
                currentKey={
                  AccountCurrentView.OfertaHandlowaZPrzykładowymiIndeksami
                }
              />
            </div>
          )}
          <div className="main-container-holder">
            <div className="row">
              <div className="col-12 col-lg-2 mb-3 mb-md-0">
                <FaSquare size={20} color="var(--secondary)" /> - edytowane
                komórki
              </div>
              <div className="col-12 col-lg-6 text-center">
                <span className={`error-text-color ${warningTextVisibility}`}>
                  Pamiętaj aby po edycji rabatów zapisać zmiany!
                </span>
              </div>
              <div className="col-12 col-lg-4 mb-3 d-flex justify-content-start justify-content-lg-end gap-2">
                <button
                  className="btn-app-primary"
                  onClick={handleExpandAll}
                  disabled={isExpandingAll}
                >
                  Rozwiń wszystko
                </button>
                <button className="btn-app-primary" onClick={handleCollapseAll}>
                  Zwiń wszystko
                </button>
                {/* Tymczasowo ukryty - przywrócić odkomentowując
                <button
                  className="btn-app-secondary"
                  onClick={handleSaveChangesButtonClick}
                >
                  Zapisz zmiany
                </button>
                */}
              </div>
            </div>
            <TreeList
              ref={treeListRef}
              id="oferta-tree-list-advanced"
              className="custom-header-wrap"
              dataSource={dataSource}
              keyExpr="id"
              parentIdExpr="parentId"
              rootValue={0}
              showBorders={true}
              showRowLines={true}
              showColumnLines={true}
              wordWrapEnabled={true}
              autoExpandAll={false}
              noDataText="Brak danych"
              onRowExpanded={onRowExpanded}
              onRowPrepared={onRowPrepared}
              onEditorPreparing={onEditorPreparing}
              onRowUpdating={onRowUpdating}
              onRowUpdated={onRowUpdated}
              onCellPrepared={onCellPrepared}
              onCellClick={onCellClick}
              width="100%"
              height="calc(100vh - 230px)"
              columnAutoWidth={false}
            >
              <Scrolling
                mode="virtual" // Renderuje tylko widoczne wiersze - płynność przy dużych danych
                rowRenderingMode="virtual"
                useNative={true} // BARDZO WAŻNE: Włącza płynny, sprzętowy "swipe" na ekranach dotykowych
                showScrollbar="always"
              />
              <Editing mode="cell" allowUpdating={true} />
              <HeaderFilter visible={true} />

              <Column caption="Grupa rabatowa" alignment="center">
                <Column
                  name="gr"
                  caption="GR"
                  width={80}
                  allowEditing={false}
                  calculateCellValue={(data) =>
                    data.id_gr || (data.parentId === 0 ? data.id : "")
                  }
                />
                <Column
                  name="indeks"
                  caption="Indeks"
                  width={110}
                  allowEditing={false}
                  calculateCellValue={(data) =>
                    data.parentId !== 0 && !data.id_gr ? data.idWithMask : ""
                  }
                />
                <Column
                  dataField="r"
                  caption="R"
                  width={40}
                  allowEditing={false}
                  allowHeaderFiltering={false}
                  alignment="center"
                />
                <Column
                  dataField="t"
                  caption="T"
                  width={30}
                  allowEditing={false}
                  allowHeaderFiltering={false}
                  alignment="center"
                />
                <Column
                  dataField="nazwa"
                  caption="Nazwa"
                  minWidth={245}
                  allowEditing={false}
                  cellRender={(cell) =>
                    cell.data._isLoading ? (
                      <TableLoadingSpinner />
                    ) : (
                      <span>{cell.value}</span>
                    )
                  }
                />
              </Column>

              <Column caption="" alignment="center">
                <Column
                  dataField="dostawca"
                  caption="Dostawca"
                  width={140}
                  allowEditing={false}
                />
              </Column>

              <Column caption="Rabaty" alignment="center">
                <Column
                  dataField="rabatKlienta"
                  caption="Rabat klienta"
                  dataType="number"
                  width={80}
                  format="#0.00"
                  allowEditing={true}
                  allowHeaderFiltering={false}
                  editorOptions={{ min: 0, max: 100, step: 0.01 }}
                  setCellValue={(newData, value) => {
                    newData.rabatKlienta =
                      value === null || value === undefined || value === ""
                        ? 0
                        : value;
                  }}
                >
                  <RangeRule
                    min={0}
                    max={100}
                    message="Rabat musi być w zakresie od 0 do 100"
                  />
                  <CustomRule
                    validationCallback={validateDecimalPlaces}
                    message="Max 2 cyfry po przecinku"
                  />
                </Column>
                <Column
                  dataField="cenaKlienta"
                  caption="Cena klienta"
                  dataType="number"
                  width={80}
                  format="#,##0.00"
                  allowEditing={false}
                  allowHeaderFiltering={false}
                />
                <Column
                  dataField="waluta"
                  caption="Waluta"
                  width={70}
                  allowEditing={false}
                  alignment="center"
                  allowHeaderFiltering={false}
                />
                <Column
                  dataField="rabatOdCenDost"
                  caption="Rabat od cen dostawcy"
                  dataType="number"
                  width={90}
                  format="#0.00"
                  allowEditing={false}
                  allowHeaderFiltering={false}
                />
                <Column
                  dataField="rabatDost"
                  caption="Rabat dostawcy"
                  dataType="number"
                  width={90}
                  format="#0.00"
                  allowEditing={false}
                  allowHeaderFiltering={false}
                />
                <Column
                  dataField="rabatInwe"
                  caption="Rabat inwe."
                  dataType="number"
                  width={70}
                  format="#0.00"
                  allowEditing={true}
                  allowHeaderFiltering={false}
                  editorOptions={{ min: 0, max: 100, step: 0.01 }}
                  setCellValue={(newData, value) => {
                    newData.rabatInwe =
                      value === null || value === undefined || value === ""
                        ? 0
                        : value;
                  }}
                >
                  <RangeRule
                    min={0}
                    max={100}
                    message="Rabat musi być w zakresie od 0 do 100"
                  />
                  <CustomRule
                    validationCallback={validateDecimalPlaces}
                    message="Max 2 cyfry po przecinku"
                  />
                </Column>
                <Column
                  dataField="grd"
                  caption="GRD"
                  width={50}
                  allowEditing={false}
                  alignment="center"
                  allowHeaderFiltering={false}
                />
              </Column>

              <Column caption="" alignment="center">
                <Column
                  dataField="marzaMin"
                  caption="Marża min."
                  dataType="number"
                  width={70}
                  format="#0.00"
                  allowEditing={false}
                  allowHeaderFiltering={false}
                />
              </Column>

              <Column caption="Poziom 1" alignment="center">
                <Column
                  dataField="marza"
                  caption="Marża"
                  dataType="number"
                  width={65}
                  format="#0.00"
                  allowEditing={false}
                  allowHeaderFiltering={false}
                />
                <Column
                  dataField="marzaKlienta"
                  caption="Marża klienta"
                  dataType="number"
                  width={70}
                  format="#0.00"
                  allowEditing={false}
                  allowHeaderFiltering={false}
                />
                <Column
                  dataField="marzaBonus"
                  caption="Marża +bonus +skonto +projekt +inwest"
                  dataType="number"
                  width={100}
                  format="#0.00"
                  allowEditing={false}
                  alignment="center"
                  allowHeaderFiltering={false}
                />
              </Column>

              <Column caption="Rabat" alignment="center">
                <Column
                  dataField="max"
                  caption="max"
                  dataType="number"
                  width={65}
                  format="#0.00"
                  allowEditing={false}
                />
                <Column
                  dataField="max3"
                  caption="max3"
                  dataType="number"
                  width={75}
                  format="#0.00"
                  allowEditing={false}
                />
              </Column>

              <Column
                caption="Zapas maksymalny"
                alignment="center"
                visible={showZapasMaks}
              >
                <Column
                  dataField="zapas0101"
                  caption="0101"
                  dataType="number"
                  width={60}
                  format="#,##0"
                  allowEditing={false}
                  allowHeaderFiltering={false}
                />
                <Column
                  dataField="zapas0201"
                  caption="0201"
                  dataType="number"
                  width={60}
                  format="#,##0"
                  allowEditing={false}
                  allowHeaderFiltering={false}
                />
              </Column>
            </TreeList>
          </div>
        </div>
      </ErrorBoundary>
    </>
  );
};

export default CommercialOfferWithSampleIndexesPageIndex;
